export const getKeysFromObject = <T extends object>(object: T) => {
    return Object.keys(object) as (keyof typeof object)[];
};

export const getKeyByValue = <T extends object>(object: T, value: string | number) => {
    return Object.keys(object).find((key) => object[key as keyof typeof object] === value) || undefined;
};

export const getKeyByEnum = <T extends object>(
    values: { [key: string]: string },
    enumObject: T,
    enumValue: string | number
): string | undefined => {
    return Object.keys(values).find(
        (f) => f.toLocaleLowerCase() === getKeyByValue(enumObject, enumValue)?.toLocaleLowerCase()
    );
};

export const getValueByEnum = <T extends object>(
    values: Record<string, string>,
    enumObject: T,
    enumValue: string | number
): string | undefined => {
    const key = getKeyByEnum<T>(values, enumObject, enumValue);
    return key ? values[key] : undefined;
};

export const getItemsFromObject = <T extends object>(object: T) => {
    return getKeysFromObject(object).map((key) => object[key]);
};

export const getValueFromEnum = <T extends object>(enumObject: T, key: string): T[keyof T] | undefined => {
    const enumKeys = Object.keys(enumObject) as (keyof T)[];
    const matchingKey = enumKeys.find((enumKey) => enumKey.toString().toLowerCase() === key.toLowerCase());
    return matchingKey ? enumObject[matchingKey] : undefined;
};

export const chunkArray = <T,>(arr: T[], size: number): T[][] => {
    return Array.from(
        { length: Math.ceil(arr.length / size) },
        (_, index): T[] => arr.slice(index * size, (index + 1) * size)
    );
};
